import React, {Component} from 'react';

import {Link} from 'react-router-dom';

import musicalsLogo from '../assets/images/logo-musicals.png'

import tapLogo from '../assets/images/tap-logo.svg'

class Home extends Component {
    render() {
        return (
            <body>
            <section className="home-page-container">

                <header>
                    <img className="musicals-logo" src={musicalsLogo} alt="Mad about Musicals logo"/>
                    <img className="tap-logo" src={tapLogo} alt="Tap to the Top logo"/>
                </header>
                <p> Rekindle your love for the arts and use your showtune knowledge to tap your way through this interactive musical experience. Listen to your favorite hits, answer trivia questions, and show off your musical expertise with this activity! </p>
                
                <Link to="/songs" className="button-start button-primary">start</Link>
                </section>

               
            </body>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js